import { useContext } from 'react';

import LipidRawMaterialContext from '../../context/materialcapture/LipidRawMaterialContext';

import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Autocomplete from '@mui/material/Autocomplete';

const LipidRawMaterialForm = () => {
  const { 
    initialValues, lipidRawMaterialData, setLipidRawMaterialData, formErrors,
  } = useContext(LipidRawMaterialContext);

  return(
    <Grid container spacing={1} mt={1}>
      <Grid item xs={6}>
        <Autocomplete
          value={lipidRawMaterialData?.lipidType}
          onChange={(e, newValue) => 
            setLipidRawMaterialData(prev => ({
              ...prev,
              lipidType: newValue
            }))
          }
          onInputChange={(e, newValue) =>
            setLipidRawMaterialData(prev => ({
              ...prev,
              lipidType: newValue
            }))
          }
          options={Object.keys(initialValues?.lipids)}
          renderInput={(params) => (
            <TextField 
              {...params} 
              label="Lipid Type *" 
              placeholder="Type to search Lipid type..." 
              error={'lipidType' in formErrors}
              helperText={formErrors['lipidType']}
            />
          )}
          freeSolo
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <Autocomplete
          value={lipidRawMaterialData?.lipidName}
          onChange={(e, newValue) => 
            setLipidRawMaterialData(prev => ({
              ...prev,
              lipidName: newValue
            }))
          }
          onInputChange={(e, newValue) =>
            setLipidRawMaterialData(prev => ({
              ...prev,
              lipidName: newValue
            }))
          }
          options={
            lipidRawMaterialData?.lipidType !== null ? 
            initialValues?.lipids[lipidRawMaterialData?.lipidType] === undefined ? [] : 
            initialValues?.lipids[lipidRawMaterialData?.lipidType]: 
            []
          }
          renderInput={(params) => (
            <TextField 
              {...params} 
              label="Lipid Name *" 
              placeholder="Type to search Lipid name..." 
              error={'lipidName' in formErrors}
              helperText={formErrors['lipidName']}
            />
          )}
          freeSolo
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <Autocomplete
          value={lipidRawMaterialData?.supplier}
          onChange={(e, newValue) => 
            setLipidRawMaterialData(prev => ({
              ...prev,
              supplier: newValue
            }))
          }
          onInputChange={(e, newValue) =>
            setLipidRawMaterialData(prev => ({
              ...prev,
              supplier: newValue
            }))
          }
          options={initialValues?.supplierArray}
          renderInput={(params) => (
            <TextField 
              {...params} 
              label="Supplier *" 
              placeholder="Type to search Supplier..." 
              error={'supplier' in formErrors}
              helperText={formErrors['supplier']}
            />
          )}
          freeSolo
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <Autocomplete
          value={lipidRawMaterialData?.productCode}
          onChange={(e, newValue) => 
            setLipidRawMaterialData(prev => ({
              ...prev,
              productCode: newValue
            }))
          }
          onInputChange={(e, newValue) =>
            setLipidRawMaterialData(prev => ({
              ...prev,
              productCode: newValue
            }))
          }
          options={initialValues?.productCodeArray}
          renderInput={(params) => (
            <TextField 
              {...params} 
              label="Product code *" 
              placeholder="Type to search Product code..." 
              error={'productCode' in formErrors}
              helperText={formErrors['productCode']}
            />
          )}
          freeSolo
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <Autocomplete
          value={lipidRawMaterialData?.lotNumber}
          onChange={(e, newValue) => 
            setLipidRawMaterialData(prev => ({
              ...prev,
              lotNumber: newValue
            }))
          }
          onInputChange={(e, newValue) =>
            setLipidRawMaterialData(prev => ({
              ...prev,
              lotNumber: newValue
            }))
          }
          options={initialValues?.lotNumberArray}
          renderInput={(params) => (
            <TextField 
              {...params} 
              label="Lot number" 
              placeholder="Type to search Lot number..." 
              error={'lotNumber' in formErrors}
              helperText={formErrors['lotNumber']}
            />
          )}
          freeSolo
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Number of ionisable groups"
          name='numberOfIonisableGroups'
          value={lipidRawMaterialData?.numberOfIonisableGroups}
          onChange={e =>
            setLipidRawMaterialData(prev => ({
              ...prev,
              numberOfIonisableGroups: e.target.value
            }))
          }
          type='number'
          helperText={formErrors['numberOfIonisableGroups']}
          error={'numberOfIonisableGroups' in formErrors}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Molecular weight (g/mol)"
          name='molecularWeight'
          value={lipidRawMaterialData?.molecularWeight}
          onChange={e =>
            setLipidRawMaterialData(prev => ({
              ...prev,
              molecularWeight: e.target.value
            }))
          }
          type='number'
          helperText={formErrors['molecularWeight']}
          error={'molecularWeight' in formErrors}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="CAS Number"
          name='CASNumber'
          value={lipidRawMaterialData?.CASNumber}
          onChange={e =>
            setLipidRawMaterialData(prev => ({
              ...prev,
              CASNumber: e.target.value
            }))
          }
          fullWidth
        />
      </Grid>
    </Grid>
  );
};

export default LipidRawMaterialForm;